import { useEffect } from 'react'

import Main from '@/widgets/main'

import { $userToken } from '@/entities/user'
import { useUnit } from 'effector-react'

import { authUserFx } from '@/entities/user'

import WebApp from '@twa-dev/sdk'
import { useScrollRestoration } from '@/shared/hooks/useRestoreScroll'

export const MainView = () => {
  //123
  const userToken = useUnit($userToken)
  useScrollRestoration()
  useEffect(() => {
    if (userToken == null) {
      authUserFx({
        init_data: WebApp.initData,
      })
    }
  }, [userToken])

  return <Main />
}
